import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import type { Response, Product } from "../interfaces";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Product"],
  endpoints: (builder) => ({
    getProducts: builder.query<Response<Product[]>, void>({
      query: () => ({
        url: "products",
        method: "GET",
      }),
      providesTags: ["Product"],
    }),
    getProduct: builder.query<Response<Product>, string>({
      query: (id) => ({
        url: `products/${id}`,
        method: "GET",
      }),
      providesTags: ["Product"],
    }),
    createProduct: builder.mutation<Response<Product>, Partial<Product>>({
      query: (product) => ({
        url: "products",
        method: "POST",
        data: product,
      }),
      invalidatesTags: ["Product"],
    }),
    updateProduct: builder.mutation<
      Response<Product>,
      { id: string; data: Partial<Product> }
    >({
      query: ({ id, data }) => ({
        url: `products/${id}`,
        method: "PUT",
        data,
      }),
      invalidatesTags: ["Product"],
    }),
    deleteProduct: builder.mutation<Response<void>, string>({
      query: (id) => ({
        url: `products/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Product"],
    }),
    toggleProductStatus: builder.mutation<
      Response<Product>,
      { id: string; is_active: boolean }
    >({
      query: ({ id, is_active }) => ({
        url: `products/${id}/status`,
        method: "PATCH",
        data: { is_active },
      }),
      invalidatesTags: ["Product"],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useToggleProductStatusMutation,
} = productApi;

